// What the Copilot box should suggest asking the knowledge base.
//
// 2026-10-02 (contact a7d03cd7): the box kept showing the caller's last
// question to the BOT ("...tell me about god and if you exists") while the
// caller was telling the agent about a billing and privacy complaint. The seed
// came only from the AI handover and never moved once the agent was on.
//
// Now: the handover question is the starting suggestion; once the caller has
// said something substantive to the agent (live transcript feed), that line
// takes over. Pure functions so scripts/verify-copilot-suggestion.mjs can
// prove them without a browser.

const FILLER = /^(?:yeah|yes|yep|no|nope|ok|okay|sure|right|thanks|thank you|hello|hi|hi there|um|uh|mm|hmm|alright|cool|great|good|fine|bye|goodbye)[\s,.!?]*$/i;
export const MIN_WORDS = 5;

function substantive(text) {
  const t = String(text || "").trim();
  if (!t || FILLER.test(t)) return false;
  return t.split(/\s+/).length >= MIN_WORDS;
}

// The latest substantive caller line from the live feed, or null.
export function liveCallerLine(lines) {
  const arr = Array.isArray(lines) ? lines : [];
  for (let i = arr.length - 1; i >= 0; i--) {
    const l = arr[i];
    if (l && l.speaker === "Cust" && !l.typing && typeof l.text === "string" && substantive(l.text)) return l.text.trim();
  }
  return null;
}

// { text, source: 'live' | 'handover' } or null.
export function pickSuggestion(escalation, lines) {
  const live = liveCallerLine(lines);
  if (live) return { text: live, source: "live" };
  const esc = escalation ?? {};
  const handover = esc.trigger ? (esc.handoverQuestion || null) : (esc.lastQuestion ?? null);
  return handover ? { text: handover, source: "handover" } : null;
}

export const SUGGESTION_LABEL = {
  live: "Suggested from what the caller just said",
  handover: "Suggested from the caller’s question to the AI",
};

// Only replace the box when the agent has not made it their own: empty or
// still holding the last auto-fill, nothing loading, and no answer on screen
// (they may be reading it).
export function shouldAutofill({ suggestion, question, lastAuto, hasAnswer, loading }) {
  if (!suggestion || suggestion === lastAuto) return false;
  if (loading || hasAnswer) return false;
  const q = String(question || "");
  return q.trim() === "" || q === (lastAuto || "");
}
